import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, Grid, Icon, Typography} from '@material-ui/core';


const StoreConfiguration = () => {
  const {profile, userStoreData} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};

  return (
    <div className="p-8">
      <Grid spacing={3} container className="text-center">
        {permissions?.settingsRequestOneLoginAccess &&
          <Grid item xs={12} sm={3} md={2} className="relative" >
            <Link to="/configurations/users-access" >
              <Card
                className="py-8 light-blue-on-hover h-full flex-column justify-center items-center"
                elevation={8}
                title="Click here to add the names and email addresses of those people on your staff that will need logins to your DermPRO store back-end, and/or additional logins for your merchant processing account"
              >
                <Icon className="text-40" color="primary">person_add_alt</Icon>
                <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Users Access</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {permissions?.settingsRewards &&
          <Grid item xs={12} sm={3} md={2} title="Click here to configure your frequent shopper reward program criteria">
            <Link to="/configurations/rewards">
              <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">monetization_on</Icon>
                <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Rewards</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {permissions?.settingsTaxRates &&
          <Grid item xs={12} sm={3} md={2} className="relative">
            <Link to="/configurations/tax-rates">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">rate_review</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Tax Rates</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {permissions?.settingsReferralProgram &&
          <Grid item xs={12} sm={3} md={2}>
            <Link to="/configurations/referral-program">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">group</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Referral Program</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {permissions?.settingsShipping &&
        <Grid item xs={12} sm={3} md={2} title="Click here to configure your flat shipping rate and your minimum threshold for free shipping">
          <Link to="/configurations/shipping">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">local_shipping</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Shipping</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsReview &&
        <Grid item xs={12} sm={3} md={2} title="Click here to determine who can write reviews and post them on your store">
          <Link to="/configurations/reviews">
            <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">star</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Reviews</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsNotifications &&
        <Grid item xs={12} sm={3} md={2} title="Click here to select what triggers an email to be sent to your customer">
          <Link to="/configurations/notifications">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">email</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Notifications</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsPickupLocations &&
        <Grid item xs={12} sm={3} md={2} title="Click here to give your customers the option not to pay for shipping, and pick they items at your office instead">
          <Link to="/configurations/store-pickup-locations">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">store</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Store Pickup</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsWhishlist &&
        <Grid item xs={12} sm={3} md={2} title="Click here to allow your customers to add products to a Wishlist they can revisit at a later time">
          <Link to="/configurations/wishlist">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">view_list</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Wishlist</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsCompare &&
        <Grid item xs={12} sm={3} md={2} title="Click here to your customers to add several items to be compared side by side">
          <Link to="/configurations/comparelist">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">compare</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Compare List</Typography>
            </Card>
          </Link>
        </Grid>
        }
        {permissions?.settingsSurveyQuestions &&
          <Grid item xs={12} sm={3} md={2} title="Click here to add a list of your providers/staff that can be recognized by your customers for outstanding customer service">
            <Link to="/configurations/survey-question">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">fact_check</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Survey Question</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {permissions?.settingsSummary && !userStoreData?.isOldMigrated &&
          <Grid item xs={12} sm={3} md={2} title="Click here to review your selections and compare them to the default values">
            <Link to="/configurations/summary">
              <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">summarize</Icon>
                <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Summary</Typography>
              </Card>
            </Link>
          </Grid>
        }
        {permissions?.auditLogs &&
          <Grid item xs={12} sm={3} md={2} >
            <Link to="/audit-logs">
              <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">sync_problem</Icon>
                <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Audit Logs</Typography>
              </Card>
            </Link>
          </Grid>
        }
        <Grid item xs={12} sm={3} md={2} >
          <Link to="/configurations/store-configuration-emails">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">alternate_email</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Store Emails</Typography>
            </Card>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

export default StoreConfiguration;
